// extracted by mini-css-extract-plugin
export default {"faixaplanos":"Internet_faixaplanos__c3S+f"};